import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/GestionExcusas.css';

const GestionExcusas = () => {
  const [excusas, setExcusas] = useState([]);
  const [estadisticas, setEstadisticas] = useState(null);
  const [filtro, setFiltro] = useState('todas'); // todas, pendientes, cumplidas, vencidas
  const [loading, setLoading] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [excusaSeleccionada, setExcusaSeleccionada] = useState(null);

  useEffect(() => {
    cargarExcusas();
    cargarEstadisticas();
  }, [filtro]);

  const cargarExcusas = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      let url = '/excusas';
      
      if (filtro === 'pendientes') {
        url += '?cumplida=false';
      } else if (filtro === 'cumplidas') {
        url += '?cumplida=true';
      } else if (filtro === 'vencidas') {
        url += '?vencidas=true';
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        setExcusas(response.data.excusas);
      }
    } catch (error) {
      console.error('Error cargando excusas:', error);
    } finally {
      setLoading(false);
    }
  };

  const cargarEstadisticas = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        '/excusas/estadisticas',
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setEstadisticas(response.data.estadisticas);
      }
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    }
  };

  const marcarCumplida = async (excusaId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `window.location.origin/api/excusas/${excusaId}/cumplir`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert('✅ Excusa marcada como cumplida');
      cargarExcusas();
      cargarEstadisticas();
    } catch (error) {
      alert('Error al marcar excusa');
      console.error(error);
    }
  };

  const getCategoriaIcon = (categoria) => {
    const iconos = {
      'enfermedad': '🏥',
      'trabajo': '💼',
      'viaje': '✈️',
      'familiar': '👨‍👩‍👧',
      'economica': '💸',
      'otra': '📝'
    };
    return iconos[categoria] || '📝';
  };

  const getCategoriaColor = (categoria) => {
    const colores = {
      'enfermedad': '#e74c3c',
      'trabajo': '#3498db',
      'viaje': '#9b59b6',
      'familiar': '#e67e22',
      'economica': '#f39c12',
      'otra': '#95a5a6'
    };
    return colores[categoria] || '#95a5a6';
  };

  const estaVencida = (excusa) => {
    if (!excusa.fecha_promesa || excusa.cumplida) return false;
    return new Date(excusa.fecha_promesa) < new Date();
  };

  return (
    <div className="gestion-excusas">
      <div className="page-header">
        <h1>📋 Gestión de Excusas</h1>
        <p>Seguimiento de excusas y promesas de pago</p>
      </div>

      {/* Estadísticas */}
      {estadisticas && (
        <div className="estadisticas-grid">
          <div className="stat-card">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <div className="stat-value">{estadisticas.total}</div>
              <div className="stat-label">Total Excusas</div>
            </div>
          </div>

          <div className="stat-card green">
            <div className="stat-icon">✅</div>
            <div className="stat-content">
              <div className="stat-value">{estadisticas.cumplidas}</div>
              <div className="stat-label">Cumplidas</div>
            </div>
          </div>

          <div className="stat-card orange">
            <div className="stat-icon">⏳</div>
            <div className="stat-content">
              <div className="stat-value">{estadisticas.pendientes}</div>
              <div className="stat-label">Pendientes</div>
            </div>
          </div>

          <div className="stat-card red">
            <div className="stat-icon">⚠️</div>
            <div className="stat-content">
              <div className="stat-value">{estadisticas.vencidas}</div>
              <div className="stat-label">Vencidas</div>
            </div>
          </div>

          <div className="stat-card purple">
            <div className="stat-icon">📈</div>
            <div className="stat-content">
              <div className="stat-value">{estadisticas.tasa_cumplimiento}%</div>
              <div className="stat-label">Tasa Cumplimiento</div>
            </div>
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="excusas-filters">
        <button 
          className={filtro === 'todas' ? 'active' : ''}
          onClick={() => setFiltro('todas')}
        >
          📋 Todas ({estadisticas?.total || 0})
        </button>
        <button 
          className={filtro === 'pendientes' ? 'active' : ''}
          onClick={() => setFiltro('pendientes')}
        >
          ⏳ Pendientes ({estadisticas?.pendientes || 0})
        </button>
        <button 
          className={filtro === 'vencidas' ? 'active' : ''}
          onClick={() => setFiltro('vencidas')}
        >
          ⚠️ Vencidas ({estadisticas?.vencidas || 0})
        </button>
        <button 
          className={filtro === 'cumplidas' ? 'active' : ''}
          onClick={() => setFiltro('cumplidas')}
        >
          ✅ Cumplidas ({estadisticas?.cumplidas || 0})
        </button>
      </div>

      {/* Lista de Excusas */}
      <div className="excusas-container">
        {loading ? (
          <div className="loading">Cargando excusas...</div>
        ) : excusas.length === 0 ? (
          <div className="empty-state">
            <p>📭 No hay excusas registradas</p>
          </div>
        ) : (
          <div className="excusas-list">
            {excusas.map(excusa => (
              <div 
                key={excusa.id} 
                className={`excusa-card ${estaVencida(excusa) ? 'vencida' : ''} ${excusa.cumplida ? 'cumplida' : ''}`}
              >
                <div className="excusa-header">
                  <div className="excusa-categoria" style={{ backgroundColor: getCategoriaColor(excusa.categoria) }}>
                    {getCategoriaIcon(excusa.categoria)} {excusa.categoria || 'Otra'}
                  </div>
                  <div className="excusa-fecha">
                    {new Date(excusa.fecha_excusa).toLocaleDateString()}
                  </div>
                </div>

                <div className="excusa-content">
                  <div className="excusa-cliente">
                    <strong>👤 {excusa.cliente_nombre}</strong>
                    <span className="cliente-cedula">{excusa.cliente_cedula}</span>
                    {excusa.cliente_telefono && (
                      <a href={`tel:${excusa.cliente_telefono}`} className="cliente-telefono">
                        📞 {excusa.cliente_telefono}
                      </a>
                    )}
                  </div>

                  <div className="excusa-texto">
                    💬 "{excusa.excusa}"
                  </div>

                  {excusa.fecha_promesa && (
                    <div className={`excusa-promesa ${estaVencida(excusa) ? 'vencida' : ''}`}>
                      🗓️ Promesa de pago: {new Date(excusa.fecha_promesa).toLocaleDateString()}
                      {excusa.monto_prometido && (
                        <span className="monto-prometido">💰 ${excusa.monto_prometido.toLocaleString()}</span>
                      )}
                    </div>
                  )}

                  {excusa.observaciones && (
                    <div className="excusa-observaciones">
                      📝 {excusa.observaciones}
                    </div>
                  )}

                  {excusa.cobrador_nombre && (
                    <div className="excusa-cobrador">
                      👨‍💼 Registrada por: {excusa.cobrador_nombre}
                    </div>
                  )}
                </div>

                <div className="excusa-actions">
                  {!excusa.cumplida && (
                    <button 
                      className="btn-cumplir"
                      onClick={() => marcarCumplida(excusa.id)}
                    >
                      ✅ Marcar Cumplida
                    </button>
                  )}
                  {excusa.cumplida && (
                    <div className="excusa-cumplida-info">
                      ✅ Cumplida el {new Date(excusa.fecha_cumplimiento).toLocaleDateString()}
                    </div>
                  )}
                  {estaVencida(excusa) && !excusa.cumplida && (
                    <span className="badge-vencida">⚠️ VENCIDA</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Estadísticas por Categoría */}
      {estadisticas && estadisticas.por_categoria && estadisticas.por_categoria.length > 0 && (
        <div className="categorias-stats">
          <h3>📊 Excusas por Categoría</h3>
          <div className="categoria-grid">
            {estadisticas.por_categoria.map(cat => (
              <div key={cat.categoria} className="categoria-item">
                <span className="categoria-icon" style={{ color: getCategoriaColor(cat.categoria) }}>
                  {getCategoriaIcon(cat.categoria)}
                </span>
                <span className="categoria-nombre">{cat.categoria}</span>
                <span className="categoria-total">{cat.total}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Clientes con más excusas */}
      {estadisticas && estadisticas.clientes_frecuentes && estadisticas.clientes_frecuentes.length > 0 && (
        <div className="clientes-frecuentes">
          <h3>⚠️ Clientes con Más Excusas</h3>
          <table className="tabla-frecuentes">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Total Excusas</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {estadisticas.clientes_frecuentes.map(cliente => (
                <tr key={cliente.id}>
                  <td>{cliente.nombre}</td>
                  <td>
                    <span className="badge-excusas">{cliente.total_excusas}</span>
                  </td>
                  <td>
                    <button 
                      className="btn-ver-cliente"
                      onClick={() => window.location.href = `/invramirez/clientes/${cliente.id}`}
                    >
                      Ver Cliente
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default GestionExcusas;

